import { render, staticRenderFns } from "./Single.vue?vue&type=template&id=937bad62&scoped=true&"
import script from "./Single.vue?vue&type=script&lang=js&"
export * from "./Single.vue?vue&type=script&lang=js&"
import style0 from "./Single.vue?vue&type=style&index=0&id=937bad62&prod&lang=scss&scoped=true&"
import style1 from "./Single.vue?vue&type=style&index=1&id=937bad62&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937bad62",
  null
  
)

export default component.exports